import { useState } from 'react';
import { useGameStore } from '../../store/gameStore';

const PLAYER_OPTIONS = [3, 4, 5, 6] as const;

export function SetupModal() {
  const phase = useGameStore((s) => s.game.phase);
  const dispatch = useGameStore((s) => s.dispatch);
  const [playerCount, setPlayerCount] = useState<number>(4);

  if (phase !== 'setup') return null;

  return (
    <div className="overlay-panel mx-auto max-w-sm p-5">
      <h1 className="text-xl font-bold text-amber-100">미션 다이스 포커</h1>
      <p className="mt-2 text-sm text-white/75">
        3D 테이블에서 미션 카드와 주사위 드래프트를 즐겨 보세요.
      </p>
      <div className="mt-4">
        <p className="mb-2 text-sm font-medium text-white/85">플레이어 수</p>
        <div className="grid grid-cols-4 gap-2">
          {PLAYER_OPTIONS.map((count) => (
            <button
              key={count}
              type="button"
              className={`min-h-[44px] touch-manipulation rounded-xl py-2.5 text-sm font-semibold transition ${
                playerCount === count ? 'bg-amber-400 text-black' : 'bg-white/5 text-white hover:bg-white/10'
              }`}
              onClick={() => setPlayerCount(count)}
            >
              {count}인
            </button>
          ))}
        </div>
      </div>
      <button
        type="button"
        className="overlay-button-primary mt-5 min-h-[44px] w-full"
        onClick={() => dispatch({ type: 'SETUP', playerCount })}
      >
        게임 시작
      </button>
    </div>
  );
}
